// extracted by css-extract-rspack-plugin
export default {"labelList":"Labels-module__labelList__WuPWG","labelItem":"Labels-module__labelItem__KZqOn","emptyState":"Labels-module__emptyState__dTJDz"};